import { useContext, createContext, useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { api } from '../../../../../services/api';


const ClubeContext = createContext()


export const ClubeProvider = ({ children }) => {
    const [mainPageProperties, setMainPageProperties] = useState([])
    const [primaryBanners, setPrimaryBanners] = useState([])
    const [secondaryBanners, setSecondaryBanners] = useState([])
    const [announcements, setAnnouncements] = useState([])

    const [modalFormsGenericIsOpen, setModalFormsGenericIsOpen] = useState(false)
    const [modalFormsMainIsOpen, setModalFormsMainIsOpen] = useState(false)
    const [modalTitleAndRoute, setModalTitleAndRoute] = useState({title: '', route: '', create: 0})

    const [datasToEdit, setDatasToEdit] = useState(null)

    const [loading, setLoading] = useState(true)

    const [mainPageToEdit, setMainPageToEdit] = useState(null)
    
    
    function verifyingCreateSetter(route, datas) {
        switch (route) {
            case '/createPrimaryBanner':
                return setPrimaryBanners([...primaryBanners, datas])
            case '/createSecondaryBanner':
                return setSecondaryBanners([...secondaryBanners, datas])
            case '/createAnnouncement':
                return setAnnouncements([...secondaryBanners, datas])
            default:
                return
        }
       
    }

    function updateList(list, datas) {
        list.map((banner, index) => {
            if(banner.id === datas.id)
                list[index] = datas
            
            return null
        })
    }

    function updateSetter(route, datas) {
        switch (route) {
            case '/updatePrimaryBanner':
                return updateList(primaryBanners, datas)
            case '/updateSecondaryBanner':
                return updateList(secondaryBanners, datas)
            case '/updateAnnouncement':
                return updateList(secondaryBanners, datas)
            default:
                return
        }
    }
   
    function deletingFromList(list, set, id) {
        const newArray = [...list]
        const filteredList = newArray.filter(banner => banner.id !== id)
        set(filteredList)
    }

    function deleteElement(route, id) {
        switch (route) {
            case '/deletePrimaryBanner':
                return deletingFromList(primaryBanners, setPrimaryBanners, id)
            case '/deleteSecondaryBanner':
                return deletingFromList(secondaryBanners, setSecondaryBanners, id)
            case '/deleteAnnouncement':
                return deletingFromList(announcements, setAnnouncements, id)
            default:
                return
        }
    }


    const pushingMainPageProperties = useCallback(object => {
        setMainPageProperties([...mainPageProperties, object])
    }, [mainPageProperties])

    const deleteMainPageProperties = useCallback(id => {
        const newArray = [...mainPageProperties]
        const filteredList = newArray.filter(banner => banner.id !== id)
        setMainPageProperties(filteredList)
    }, [mainPageProperties])

    const editMainPageProperties = useCallback(object => {
        mainPageProperties.map((properties, index) => {
            if(properties.id === object.id)
                mainPageProperties[index] = object
            return null
        })
    }, [mainPageProperties])

    const handleDeleteMainProperty = useCallback(async id => {
        if(mainPageProperties.length === 0){
            toast.error('Impossível deletar')
            return
        }

        try{
            const response = await api.delete(`/deleteMainPageProperties/${id}`)

            const { success } = response.data

            if(success){
                deleteMainPageProperties(id)
                toast.success('Deletado com sucesso')
            }

        }catch(error){
            toast.error('Algo deu errado, tente novamente')
        }
    }, [deleteMainPageProperties, mainPageProperties])

    const handleSwitchButtonMainPage = useCallback( async id => {
        let newArray = [...mainPageProperties]
        let IdIsActive = newArray.find(property => property.id === id).active
      
        if(IdIsActive)
            return
        
        newArray.map(property => (
            property.id === id ? property.active = true : property.active = false
        ))

        setMainPageProperties(newArray)
       
        try{
            const response = await api.patch('/activeMainPageProperties', { id }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            const { success } = response.data
           
            if(!success)
                throw new Error()

        }catch{
            toast.error("Algo deu errado, tente novamente")
        }

    }, [mainPageProperties])


    useEffect(() => {
        async function fetchData() {
            try{
                await api.get('/getInoveClubeProperties/0').then(response => {
                    setMainPageProperties(response.data.mainPageProperties)
                    setPrimaryBanners(response.data.primaryBanners)
                    setSecondaryBanners(response.data.secondaryBanners)
                    setAnnouncements(response.data.announcements)
                })
                setLoading(false)
            }
            catch(error){
                setLoading(false)
                toast.error(error)
            }   
        }
        fetchData()
    }, [])


    return (
        <ClubeContext.Provider value={{ 
            mainPageProperties,
            primaryBanners,
            secondaryBanners,
            announcements,
            loading,
            
            modalTitleAndRoute, setModalTitleAndRoute,
            modalFormsGenericIsOpen, setModalFormsGenericIsOpen,
            datasToEdit, setDatasToEdit,

            modalFormsMainIsOpen, setModalFormsMainIsOpen,
            mainPageToEdit, setMainPageToEdit,

            verifyingCreateSetter, updateSetter, deleteElement,
            handleSwitchButtonMainPage, pushingMainPageProperties, handleDeleteMainProperty, editMainPageProperties
        }}>
            {children}
        </ClubeContext.Provider>
    );
}

export function useClube() {
    const context = useContext(ClubeContext);

    if(!context) {
        throw new Error('useClube must be used within an AuthProvider');
    }

    return context;
}
